/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const USERFLOW_TOKEN = String(process.env.REACT_APP_USERFLOW_TOKEN);

// Mapping of content ids utilized by Userflow to show tour guides
export const USERFLOW_CONTENT_IDS = {
  NoEnvironment: "285ef589-f8cc-4313-9485-9135090cd559",
  NoPrimaryBusinessContext: "3a07cfc8-6b3b-4cb0-b294-cdd8ff63564d",
};
